import {readable} from 'svelte/store';
import {psychiatryAdult} from "./services/psychiatry_adult";
import {psychiatryChildren} from "./services/psychiatry_children";
import {psychiatryElder} from "./services/psychiatry_elder";
import {psychoterapyAdult} from "./services/psychoterapy_adult";
import {psychoterapyChildren} from "./services/psychoterapy_children";
import {psychoterapyPair} from "./services/psychoterapy_pair";
import {psychoterapyParents} from "./services/psychoterapy_parents";
import {psychologyConsultation} from "./services/psychology_consultation";
import {psychologyCognitive} from "./services/psychology_cognitive";
import {psychologyIq} from "./services/psychology_iq";
import {psychologyPersonality} from "./services/psychology_personality";
import {sexuologyConsultation} from "./services/sexuology_consultation";
import {psychoterapyEmdr} from "./services/psychoterapy_emdr";
import {socialSkillsTraining} from "./services/social_skills_training";
import {developmentGroup} from "./services/development_group";
import {taleTherapy} from "./services/tale_therapy";
import {domesticViolenceSupport} from "./services/domestic_violence_support";
import {psychoterapySystem} from "./services/psychoterapy_system";
import {crisisIntervention} from "./services/crisis_intervention";
import {preventionGroup} from "./services/prevention_group";
import {psychoterapyFamily} from "./services/psychoterapy_family";
import {autismDiagnosis} from "./services/autism_diagnosis";
import {asdDiagnosis} from "./services/asd_diagnosis";
import {adhdDiagnosis} from "./services/adhd_diagnosis";


export const services = readable({}, function start(set) {
    set({
        'psychiatry': {
            'adult': psychiatryAdult,
            'children': psychiatryChildren,
            'elder': psychiatryElder,
        },
        'psychoterapy': {
            'adult': psychoterapyAdult,
            'children': psychoterapyChildren,
            'pair': psychoterapyPair,
            'parents': psychoterapyParents,
            'emdr': psychoterapyEmdr,
            'system': psychoterapySystem,
            'family': psychoterapyFamily
        },
        'psychology': {
            'consultation': psychologyConsultation,
            'cognitive': psychologyCognitive,
            'iq': psychologyIq,
            'personality': psychologyPersonality,
            'crisisIntervention': crisisIntervention
        },
        'diagnosis': {
            'autism': autismDiagnosis,
            'asd': asdDiagnosis,
            'adhd': adhdDiagnosis,
        },
        'sexuology': {
            'consultation': sexuologyConsultation
        },
        'group': {
            'socialSkills': socialSkillsTraining,
            'domesticViolenceSupport': domesticViolenceSupport,
            'developmentGroup': developmentGroup,
            // 'supportGroupGestalt': supportGroupGestalt,
            // 'developmentGroupYoung': developmentGroupYoung,
            // 'developmentGroupAdult': developmentGroupAdult,
            'preventionGroup': preventionGroup,
            // 'abandonedGroup': abandonedGroup,
            'taleTherapy': taleTherapy,
            // 'parentGroup': parentGroup
        },
        'categorized': {
            'psychiatry': {
                'title': 'PSYCHIATRIA',
                'services': {
                    'psychiatryAdult': {
                        'service': psychiatryAdult,
                        'description': '<p>Zadaniem lekarza psychiatry jest diagnozowanie i leczenie chorób i zaburzeń psychicznych. Terapia psychiatryczna ma na celu usunięcie objawów chorobowych i poprawę funkcjonowania pacjenta co nazywane jest również remisją.</p>'
                    },
                    'psychiatryChildren': {
                        'service': psychiatryChildren,
                        'description': '<p>Psychiatra dzieci i młodzieży dzięki zdobytej wiedzy na temat wielu czynników, w tym czynników biologicznych i psychologicznych, opracowuje plan leczenia dziecka z zaburzeniami zachowania, myśli i emocji.</p>'
                    },
                    'psychiatryElder': {
                        'service': psychiatryElder,
                        'description': '<p>Psychogeriatra jest to lekarz psychiatra, który posiada doświadczenie w leczeniu pacjentów powyżej 65 roku życia. Doświadczenie to łączy w sobie wiedzę psychiatryczną, wiedzę dotyczącą chorób wewnętrznych z uwzględnieniem chorób nasilających się w wieku podeszłym oraz wiedzę z zakresu neurologii.</p><p>Zadaniem psychogeriatry jest diagnozowanie i leczenie chorób i zaburzeń psychicznych u osób starszych.</p>'
                    }
                }
            },
            'adultPsychoterapy': {
                'title': 'PSYCHOTERAPIA DOROSŁYCH',
                'services': {
                    'psychoterapyAdult': {
                        'service': psychoterapyAdult,
                        'description': '<p>Psychoterapia to leczenie oparte na szczególnej relacji pomiędzy pacjentem, a psychoterapeutą. Ta metoda pozwala na otwartą rozmowę z osobą, która jest obiektywna, neutralna i nieoceniająca.</p><p>Pacjent wraz z psychoterapeuta pracują razem, aby zidentyfikować i zmienić wzorce myślenia, a także zachowania, które nie pozwalają czuć się lepiej.</p>'
                    },
                    'psychotherapyPair': {
                        'service': psychoterapyPair,
                        'description': '<p>Terapia nakierowana jest na zrozumienie myśli, zachowań i emocji obojga partnerów, które wpływają na nieprawidłowe relacje w związku. Bardzo istotnymi czynnikami umożliwiającymi przeprowadzenie terapii są: wysoka motywacja obojga partnerów, brak zaangażowania któregokolwiek z partnerów w związek pozamałżeński oraz niestosowanie przemocy.</p>'
                    },
                    'psychoterapyEmdr': {
                        'service': psychoterapyEmdr,
                        'description': '<p>Terapia EMDR (eye movement desensitization and reprocessing - odwrażliwianie i przetwarzanie za pomocą ruchu gałek ocznych) to metoda terapeutyczna rekomendowana przez Światową Organizację Zdrowia i Amerykańskie Towarzystwo Psychiatryczne jako jedna z dwóch (obok psychoterapii poznawczo-behawioralnej) najskuteczniejszych metod leczenia traumy.</p>'
                    }
                }
            },
            'childrenPsychoterapy': {
                'title': 'PSYCHOTERAPIA DZIECI I MŁODZIEŻY',
                'services': {
                    'psychoterapyChildren': {
                        'service': psychoterapyChildren,
                        'description': '<p>Psychoterapia dla dzieci i młodzieży jest formą rozmowy pomiędzy dzieckiem/nastolatkiem, opiekunem a terapeutą. Przybiera formę indywidualnych spotkań dziecko z terapeutą, spotkań grupowych (grupa dzieci oraz terapeuta) lub dziecko + opiekun wraz z terapeutą. Wybór formy zdeterminowany jest indywidualnym problemem zgłoszonym podczas konsultacji.</p>'
                    },
                    'psychoterapyParents': {
                        'service': psychoterapyParents,
                        'description': '<p>Poradnictwo psychologiczne to forma pomocy psychologicznej, która jest zazwyczaj krótsza od typowej psychoterapii. Z poradnictwa psychologicznego mogą skorzystać osoby będące w tymczasowym kryzysie, doświadczające chwilowych trudności w swoim życiu.</p>'
                    }
                }
            },
            'psychotherapySystem': {
                'title': 'PSYCHOTERAPIA RODZINNA I SYSTEMOWA',
                'services': {
                    'psychoterapyFamily': {
                        'service': psychoterapyFamily,
                        'description': '<p>Terapia rodzinna koncentruje się na rozwijaniu silnych więzi między członkami rodziny, poprawianiu komunikacji i wzmacnianiu wzajemnego wsparcia, aby zapobiec i leczyć zaburzenia. Celem terapii rodzinnej jest zarządzanie trudnymi problemami i zmiana zachowań, aby poprawić jakość życia wszystkich członków rodziny.</p>'
                    },
                    'psychoterapySystem': {
                        'service': psychoterapySystem,
                        'description': '<p>Terapia systemowa to jeden z nurtów psychoterapii. Od innych nurtów psychoterapeutycznych odróżnia się tym, że nie traktuje pacjenta w sposób jednostkowy, nie skupia uwagi wyłącznie na nim, ale bazuje na systemie. System definiuje jako coś większego, spójna całość. Psychoterapia systemowa koncentruje się na systemie, w którym dany pacjent funkcjonuje na co dzień.</p>'
                    }
                }
            },
            'diagnosis': {
                'title': 'DIAGNOSTYKA',
                'services': {
                    'autism': {
                        'service': autismDiagnosis,
                        'description': '<p>Autyzm jest zaburzeniem rozwoju, które objawia się w dzieciństwie. Występuje u około 1% populacji. Autyzm jest zaburzeniem, które dotyka całą rodzinę. Wymaga od rodziców i opiekunów ogromnego zaangażowania i pracy. Wczesna diagnoza i wdrożenie odpowiednich metod terapeutycznych jest kluczowe dla rozwoju dziecka.</p>'
                    },
                    'asd': {
                        'service': asdDiagnosis,
                        'description': '<p>Diagnoza ASD u dorosłych to kompleksowy proces 3–6 spotkań, podczas których zbierane są szczegółowe informacje o historii, trudnościach i relacjach społecznych, przeprowadzana jest obserwacja ADOS-2, konsultowana hipoteza diagnostyczna, a następnie wdrażane są dalsze kroki wsparcia i podstawowa psychoedukacja.</p>'
                    },
                    'adhd': {
                        'service': adhdDiagnosis,
                        'description': '<p>Diagnoza ADHD u dorosłych to kompleksowy, 3–6 spotkań proces obejmujący zebranie szczegółowych informacji o trudnościach i historii leczenia, przeprowadzenie wywiadu DIVA 5.0, konsultację psychiatryczną oraz podstawową psychoedukację i dalsze wsparcie.</p>'
                    }
                }
            },
            'psychology': {
                'title': 'KONSULTACJE PSYCHOLOGICZNE',
                'services': {
                    'psychologyConsultation': {
                        'service': psychologyConsultation,
                        'description': '<p>Poradnictwo psychologiczne to forma pomocy psychologicznej, która jest zazwyczaj krótsza od typowej psychoterapii. Z poradnictwa psychologicznego mogą skorzystać osoby będące w tymczasowym kryzysie, doświadczające chwilowych trudności w swoim życiu.</p>'
                    },
                    'psychologyIq': {
                        'service': psychologyIq,
                        'description': '<p>Najbardziej rozpowszechnioną metodą diagnostyczną jest badanie ilorazu inteligencji. Większość ludzi niejednokrotnie zastanawiała się, jak wysokie ma IQ. Ta ciekawość może skłonić nas do wykonania profesjonalnego testu inteligencji i uzyskać prawdziwy, miarodajny wynik. Oprócz samego wskaźnika IQ badanie inteligencji pokazuje bardzo wiele użytecznych informacji pozwalających na określenie sposobu funkcjonowania pacjenta.</p>'
                    },
                    'psychologyPersonality': {
                        'service': psychologyPersonality,
                        'description': '<p>Diagnoza psychologiczna prowadzona jest na wielu obszarach. Osobowość człowieka jest jednym z ważniejszych. Osobowość definiowana jest jako zbiór właściwości psychicznych jednostki, stabilny w czasie i w różnych sytuacjach życiowych, aczkolwiek wpływający na charakterystyczne wzorce zachowań. Inaczej mówiąc osobowość definiuje w jaki sposób postrzegamy i przeżywamy siebie, innych ludzi oraz relacje z nimi, wydarzenia z naszego życia.</p>'
                    },
                    'psychologyCognitive': {
                        'service': psychologyCognitive,
                        'description': '<p>Wystąpienie zaburzeń funkcji poznawczych powinno skłonić nas do wizyty u specjalisty. Przeprowadzenie profesjonalnych testów pomoże w postawieniu właściwej diagnozy i zaplanowaniu odpowiedniej ścieżki powrotu do pełnej sprawności.</p>'
                    },
                    'crisisIntervention': {
                        'service': crisisIntervention,
                        'description': '<p>Interwencja kryzysowa jest działaniem krótkoterminowym i doraźnym, którego  celem jest udzielenie natychmiastowej pomocy w kryzysie życiowym. Interwencja kryzysowa to zespół interdyscyplinarnych, profesjonalnych, celowych i skoordynowanych oddziaływań.</p>'
                    }
                }
            },
            'sexology': {
                'title': 'KONSULTACJE SEKSUOLOGICZNE',
                'services': {
                    'sexuologyConsultation': {
                        'service': sexuologyConsultation,
                        'description': '<p>Rozmowa z seksuologiem dotyczy najbardziej intymnej sfery życia, co może wywoływać u nas poczucie wstydu. Warto jednak przełamać tę barierę i zdecydować się na rozmowę, ponieważ o udany seks powinniśmy dbać tak samo jak o zdrowe serce czy stawy. Niesatysfakcjonujące życie erotyczne dostarcza nam wiele negatywnych przeżyć, odbijających się na funkcjonowaniu całego organizmu i psychiki.</p>'
                    }
                }
            },
            'groups': {
                'title': 'TERAPIE GRUPOWE I TRENINGI',
                'services': {
                    'socialSkills': {
                        'service': socialSkillsTraining,
                        'description': '<p>Trening Umiejętności Społecznych to cykliczne zajęcia grupowe o określonej i stałej strukturze, które są ukierunkowane na rozwijanie kompetencji społecznych, komunikacyjnych i emocjonalnych. </p>'
                    },
                    'developmentGroup': {
                        'service': developmentGroup,
                        'description': '<p>Podczas spotkań będziemy rozmawiać między innymi o trudnościach, o tym co doskwiera, o troskach, o lękach. O tym co się wydarzyło, a nadal „przygniata” emocjonalnie.</p>'
                    },
                    // 'abandonedGroup': {
                    //     'service': abandonedGroup,
                    //     'description': '<p>Wspólne spotkania odbywają się w przyjaznym i wspierającym środowisku, gdzie każda z nas ma możliwość dzielenia się swoimi przeżyciami, uczuciami i myślami. W trakcie sesji będziemy razem odkrywać nasze mocne strony, rozwijać zdolności komunikacyjne oraz budować zdrowe relacje z innymi uczestniczkami grupy.</p>'
                    // },
                    'preventiveGroup': {
                        'service': preventionGroup,
                        'description': '<p>Zajęcia psychoterapii grupowej skierowane są do młodzieży, która doświadcza trudności w relacjach rodzinnych, koleżeńskich, ma trudności w regulowaniu emocji oraz kontroli impulsów, przejawia zachowania problemowe w codziennym funkcjonowaniu, np. zachowania agresywne i autoagresywne, wagary, sięganie po substancje psychoaktywne, nie przestrzega norm społecznych.</p>'
                    },
                    // 'developmentGroupGestalt': {
                    //     'service': developmentGroupGestalt,
                    //     'description': '<p>Gestalt jest nurtem humanistyczno-egzystencjalnym. Celem terapii jest  poszerzenie świadomości, co wydarza się w autentycznej, żywej relacji z terapeutą. Gestalt jest terapią holistyczną, w której  uważnością obejmuje się nie tylko myśli i wyobrażenia, ale także odczucia płynące z ciała czy chroniczne dolegliwości.</p>'
                    // },
                    // 'supportGroupGestalt': {
                    //     'service': supportGroupGestalt,
                    //     'description': '<p>Zapraszamy wszystkich, którzy znaleźli się w kryzysie psychicznym i potrzebują natychmiastowego wsparcia. W czułym i uważnym kontakcie z terapeutkami Gestalt oraz mocą płynącą z grupowego wsparcia, możesz dostać to czego teraz potrzebujesz.</p>'
                    // },
                    // 'parentGroup': {
                    //     'service': parentGroup,
                    //     'description': '<p>W naszych warsztatach "Jak Zrozumieć Nastolatka?", oferujemy rodzicom i opiekunom wyjątkową możliwość pogłębienia zrozumienia świata, w którym dorastają ich dzieci.</p>'
                    // }
                }
            }
        }
    });

    return function stop() {};
});